const LAYERS = [
  { y: 46, w: 1, h: 190 },
  { y: 38, w: 1, h: 210 },
  { y: 30, w: 0.85, h: 230 },
  { y: 22, w: 0.85, h: 250 },
  { y: 14, w: 0.7, h: 270 },
];

export default function TowerStackIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect x="2" y="2" width="60" height="60" rx="12" fill="#120a2e" />
      {LAYERS.map(({ y, w, h }, i) => {
        const hw = 20 * w;
        const hh = 9 * w;
        const cx = 32 + (i === 4 ? 4 : 0);
        return (
          <g key={i}>
            <path d={`M${cx - hw} ${y} L${cx} ${y + hh} L${cx} ${y + hh + 7} L${cx - hw} ${y + 7} Z`} fill={`hsl(${h} 65% 36%)`} />
            <path d={`M${cx + hw} ${y} L${cx} ${y + hh} L${cx} ${y + hh + 7} L${cx + hw} ${y + 7} Z`} fill={`hsl(${h} 70% 46%)`} />
            <path d={`M${cx} ${y - hh} L${cx + hw} ${y} L${cx} ${y + hh} L${cx - hw} ${y} Z`} fill={`hsl(${h} 80% 64%)`} />
          </g>
        );
      })}
    </svg>
  );
}
